import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ScrollIndicator from './components/ScrollIndicator';
import ScrollToTopRoute from './components/ScrollTopRoute';
import CookieConsent from './components/CookieConsent';
import About from './pages/About';
import Contact from './pages/Contact';
import Faq from './pages/Faq';
import Home1 from './pages/Home1';
import Services from './pages/Services';
import ServicesDetails from './pages/ServicesDetails';

function App() {
    return (
        <>
            <Router>
                <ScrollToTopRoute />
                <Switch>
                    <Route exact path="/despre-noi">
                        <About />
                    </Route>
                    <Route exact path="/intrebari-frecvente">
                        <Faq />
                    </Route>
                    <Route exact path="/servicii">
                        <Services />
                    </Route>
                    <Route exact path="/servicii/:serviceName">
                        <ServicesDetails />
                    </Route>
                    <Route exact path="/contact">
                        <Contact />
                    </Route>
                    <Route exact path="/">
                        <Home1 />
                    </Route>
                </Switch>
            </Router>
            <ScrollIndicator />
            <CookieConsent />
        </>
    );
}

export default App;
